<fieldset class="component-container">
    <div class="add-container" fxLayout fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <!--header template (divs will float right)-->
        <ng-container *ngIf="headerTemplate != null">
            <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
        </ng-container>
        
        <button
            mat-raised-button color="primary"
            *ngIf="allowAdd" (click)="addRow(); buttonEvent.emit('add');"
        > 
           <mat-icon>add</mat-icon>
        </button>
    </div>

    <!--[ngStyle]="{height: bodyHeight}"-->
    <div class="table-container" >
        <table class="table">
    
            <!--header row-->
            <thead>
                <tr>
                    <th *ngFor="let name of columnNames; let x = index;" [ngStyle]="{width: spacing[x]}">{{name}}</th>
                    <th class="hide" [ngStyle]="{width: spacing[spacing.length - 1]}"></th>
                </tr>
            </thead>

            <!--rows-->
            <tbody>
                <tr *ngFor="let item of pageArray; let i = index;" (mouseover)="mouseIndex = i;" (mouseleave)="mouseIndex = -1;">
        
                    <!--view container-->
                    <ng-container *ngIf="editIndex != i;">
                        <ng-container
                            [ngTemplateOutlet]="viewTemplate"
                            [ngTemplateOutletContext]="{$implicit: item}">
                        </ng-container>
                    </ng-container>
        
                    <!--form container-->
                    <ng-container *ngIf="editIndex == i">
                        <ng-container
                            [ngTemplateOutlet]="formTemplate"
                            [ngTemplateOutletContext]="{$implicit: item}">
                        </ng-container>
                    </ng-container>
                
        
                    <!--button container-->
                    <td [ngClass]="(mouseIndex == i || editIndex == i)? 'show button-cell': 'hide button-cell'">
                        <ng-container *ngIf="editIndex != i && editIndex == -1">
                            <ng-container *ngIf="allowEdit">
                                <button mat-icon-button enabled="mouseIndex == i" (click)="editRow(i);"><mat-icon>create</mat-icon></button>
                            </ng-container>

                            <ng-container *ngIf="allowDelete">
                                <button mat-icon-button color="accent" enabled="mouseIndex == i" (click)="deleteRow(i)"><mat-icon>delete</mat-icon></button>
                            </ng-container>

                            <ng-container *ngFor="let btn of customButtons | keyvalue" >
                                <button mat-icon-button (click)="buttonEvent.emit(btn.value); itemChange.emit({'action': btn.value, 'item': item});"><mat-icon>{{btn.key}}</mat-icon></button>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="editIndex == i">
                            <button mat-icon-button enabled="mouseIndex == i" (click)="saveChanges()" [disabled]="!isValid"><mat-icon>done</mat-icon></button>
                            <button mat-icon-button color="accent" enabled="mouseIndex == i" (click)="cancel(); buttonEvent.emit('cancel');"><mat-icon>close</mat-icon></button>
                        </ng-container>
                    </td>
        
                </tr>
            </tbody>
        </table>
    </div>
    
    <!--footer template-->
    <div class="data-margin" [ngStyle]="{width: bodyWidth}">
        <ng-container *ngIf="footerTemplate != null">
            <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
        </ng-container>
    </div>

    <!--pagination-->
    <div class="data-margin navigation-container" *ngIf="_data.length > _itemsPerPage" [ngStyle]="{width: bodyWidth}">
        <span class="centered">{{currentPage}} of {{totalPages}}</span>
        <div class="navigation-elements">
            <button mat-icon-button (click)="back(1)"><mat-icon>chevron_left</mat-icon></button>
            <button mat-icon-button (click)="forward(1)"><mat-icon>chevron_right</mat-icon></button>
        </div> 
    </div>
</fieldset>

<div *ngIf="debug">
    <h4>pageArray</h4>
    length: {{pageArray.length}}<br>
    {{pageArray | json}}
    <br>
    <h4>touchedData</h4>
    length: {{touchedData.length}}<br>
    {{touchedData | json}}
    <br>
    <h4>_data</h4>
    length: {{_data.length}}<br>
    {{_data | json}}
    <br>
</div>